<template lang="pug">
.notification-container
  transition-group(name="notification-transition")
    Notification(
      v-for="notification in notifications"
      :key="notification.id"
      :notification="notification")
</template>

<script>
import Notification from '@v/components/Notification.vue'
import { mapState } from 'vuex'

export default {
  name: 'NotificationContainer',
  components: { Notification },
  computed: mapState('notification', ['notifications']),
  mounted() {
    // Notification as a quiery param is temporary until we refactor all blade pages to vuew
    if (this.$route.query.messageSuccess) {
      this.$notifySuccess(this.$route.query.messageSuccess)
    }
  },
}
</script>

<style scoped lang="stylus">
.notification-container
  position fixed
  bottom 0
  left 0
  right 0
  display flex
  flex-direction column
  justify-content center
  align-items center
  z-index 10002

.notification-transition-enter
  transform translateY(10px)
  opacity 0

.notification-transition-leave-to
  transform translateY(-10px)
  opacity 0

.notification-transition-enter-active, .notification-transition-leave-active
  transition all .3s ease
</style>
